<div [class.macOS-moz-padding]="isMacOS">
  @for (item of items; track item) {
    <div class="body-row" (click)="onItemClick(item)" [class.has-navigation]="hasNavigation">
      @for (col of columns; track col) {
        <div
          class="body-cell"
          [class.has-navigation]="hasNavigation"
          [class.current-sort]="isCurrentSort(col)"
          [style.width]="col.colWidth ? col.colWidth + 'px' : col.calculatedPercentage + '%'"
        >
          <ng-container *ngTemplateOutlet="$any(col).templateRef; context: {$implicit: item}"></ng-container>
        </div>
      }
    </div>
  }
</div>
